import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  colors: {
    gray: {
      500: "#707479",
    },
  },
});

export default theme;
